import React, { FC, useEffect, useState } from 'react'
// Icons
import { EyeIcon, EyeClosedIcon } from 'images/icons/header/'
// Styles
import { Label_s, Svg_s } from 'styles/app-styles'
import { UpdatePasswordForm_s } from 'components/profile/profile-styles'
// Data
import profileService from 'data/profile'
import { ProfileDataWithToken } from './profile-popover'

type InputProps = {
  value: string
  onChange: any
  profileData?: ProfileDataWithToken
}

type Props = {
  profileData?: ProfileDataWithToken
}

const PasswordInput = (props: InputProps) => {
  const [visible, toggleVisible] = useState<boolean>(false);
  const { value, onChange }      = props;

  return (
    <div>
      <input
        type={visible ? "text" : "password"}
        value={value}
        onChange={onChange}
      />
      <a onClick={()=>toggleVisible(!visible)}>
        { visible ? <Svg_s src={EyeIcon} /> : <Svg_s src={EyeClosedIcon} /> }
      </a>
    </div>
  );
}

const UpdatePassword: FC<Props> = (props) => {
  const { profileData: data } = props

  return (
    <div>
      <UpdatePasswordForm_s>
        <div>
          <Label_s>Current Password</Label_s>
          <PasswordInput
            value={data!.currentPassword}
            onChange={e => profileService.updateData('currentPassword', e.target.value)}
          />
        </div>
        <div>
          <Label_s>New Password</Label_s>
          <PasswordInput
            value={data!.updatedPassword}
            onChange={e => profileService.updateData('updatedPassword', e.target.value)}
          />
        </div>
        <div>
          <Label_s>Confirm Password</Label_s>
          <PasswordInput
            value={data!.confirmNewPw}
            onChange={e => profileService.updateData('confirmNewPw', e.target.value)}
          />
        </div>
        <div style={{fontSize: '14px'}}>
          <div>Password requirements:</div>
          <br />
          <div>1. Minimum of 12 characters</div>
          <div>2. Must contain at least one upper case and lower case letter</div>
          <div>{`3. Must contain at least one of the following special characters: -#!$@£%^&*()_+|~={}[]:";'<>?,.`}</div>
          <div>4. Must not contain any part of your email address</div>
        </div>
      </UpdatePasswordForm_s>
    </div>
  )
}

export default UpdatePassword